import { ComponentClassNames } from '../../util/classNames';
import { PaletteColor } from '../../util/colors';
import { Depth, getDepthBoxShadow } from '../../util/styles/depth';
import { getGutterValue } from '../../util/styles/gutters';
import { ITheme, memoizeFunction, mergeStyleSets } from '../../util/styling';

import { BorderRadius } from './Card.types';

export const defaultCardBorderRadius = BorderRadius.VeryRound;

export interface CardClassNamesProps {
  readonly borderRadius: BorderRadius;
  readonly depth: Depth;
  readonly padding: number;
  readonly theme: ITheme;
  readonly className?: string;
  readonly backgroundColor?: PaletteColor;
}

const getClassNamesMemoized = memoizeFunction(
  (
    borderRadius: BorderRadius,
    depth: Depth,
    padding: number,
    theme: ITheme,
    className?: string,
    backgroundColor?: CardClassNamesProps['backgroundColor']
  ) =>
    mergeStyleSets({
      card: [
        {
          backgroundColor: backgroundColor
            ? theme.palette[backgroundColor]
            : theme.semanticColors.bodyStandoutBackground,
          borderRadius,
          boxShadow: getDepthBoxShadow(depth),
          overflow: 'hidden',
          padding: getGutterValue(padding),
          position: 'relative',
          transition: 'box-shadow .1s',
        },
        className,
      ],
    })
);

type GetClassNames = (props: CardClassNamesProps) => ComponentClassNames<'card'>;
export const getClassNames: GetClassNames = ({ borderRadius, depth, padding, theme, className, backgroundColor }) =>
  getClassNamesMemoized(borderRadius, depth, padding, theme, className, backgroundColor);
